
import { computed, defineComponent, onBeforeMount, PropType, ref } from 'vue';

import { format } from "date-fns";
import * as Locales from 'date-fns/locale';
import EasyDrop from '@/components/EasyDrop.vue';
import { LocaleStrings } from '@/types/paramModels';

export default defineComponent({
    name: "EasyDobPicker",
    emits: ['updateDob'],
    props: {
        dob: {
            type: String,
            default: null
        },
        pageTexts: {
            type: Object,
            required: true
        },
        localeStrings: {
            type: Object as PropType<LocaleStrings>,
            required: true
        }
    },
    components: {
        EasyDrop
    },
    setup(_props, { emit }) {
        const updatedYear = ref();
        const updatedMonth = ref();
        const updatedDate = ref();

        const yearOptions = computed(() => {
            let currentYear = new Date().getFullYear();
            const yearArray = Array<number>();

            for (let i = 120; i > 0; i--) {
                yearArray.push(currentYear);
                currentYear--;
            }

            return yearArray;
        });

        const monthMaxDate = computed(() => {
            const currentYear = updatedYear.value ?? 2000;
            const currentMonth = updatedMonth.value ?? 1;
            return new Date(currentYear, currentMonth, 0).getDate();
        });

        const yearButtonValue = computed(() => updatedYear.value?.toString());
        const monthButtonValue = computed(() => getMonthFullName(updatedMonth.value));
        const dateButtonValue = computed(() => updatedDate.value?.toString());

        const getMonthFullName = (monthIndex: number) => {
            return monthIndex ? format(new Date(2000, monthIndex - 1, 1), "LLLL", { locale: Locales[_props.localeStrings.name] }) : "";
        }

        const updateDob = () => {
            if (updatedDate.value && updatedDate.value > monthMaxDate.value)
                updatedDate.value = null;

            if (updatedYear.value && updatedMonth.value && updatedDate.value) {
                emit("updateDob", new Date(updatedYear.value, updatedMonth.value - 1, updatedDate.value)); // the month is 0-indexed
            }
        }

        onBeforeMount(() => {
            if (_props.dob) {
                updatedYear.value = format(new Date(_props.dob), "yyyy", { locale: Locales[_props.localeStrings.name] });
                updatedMonth.value = format(new Date(_props.dob), "M", { locale: Locales[_props.localeStrings.name] });
                updatedDate.value = format(new Date(_props.dob), "d", { locale: Locales[_props.localeStrings.name] });
            }
        })

        return {
            yearOptions,
            yearButtonValue,
            monthButtonValue,
            dateButtonValue,
            monthMaxDate,
            getMonthFullName,
            updateDob,
            updatedYear,
            updatedMonth,
            updatedDate
        }
    },
})
